import * as Yup from "yup";

export default Yup.object().shape({
    name: Yup.string().required("Please enter a Category name"),
    mediaTypeId: Yup.number().nullable().required("Media Type is required")
});